import React from 'react';
import { FirestoreCollection } from '@react-firebase/firestore';
import { useSessionStorage } from '../../hooks/useSessionStorage';

import './Locations.scss';

export default function Locations() {
	const [language] = useSessionStorage('language', '');
	return (
		<div className="locationsContent">
			<FirestoreCollection path="/locations/">
				{(data) =>
					!data.isLoading &&
					data.value[0].locations.map((item: any, index: number) => {
						const phoneLink = `tel:${item.phone}`;
						const mailLink = `mailto:${item.email}`;

						return (
							<div key={index} className="locationContent">
								<div className="locationTitle">
									<img src={item.flag.sm.src} alt=""></img>
									{language === 'ua' ? item.locationUa : item.location}
								</div>
								<a href={phoneLink} className="locationRow">
									{' '}
									{item.phone}
								</a>
								<a href={mailLink} className="locationRow">
									{item.email}
								</a>
							</div>
						);
					})
				}
			</FirestoreCollection>
		</div>
	);
}
